/**
 * Wer den Rahmen setzt: die Hülle oder die Seite selbst.
 *
 * Die Hülle legt um den Inhalt die Abstände des Entwurfs — 56px oben, 36px
 * seitlich, 96px unten. Das stimmt für jede Seite, die auf Papier steht.
 *
 * Es stimmt **nicht** für die Seiten, die bis an die Kante laufen. Der Entwurf
 * zeichnet drei davon:
 *
 * - **Aufgabe** und **Meilenstein** tragen rechts die schwarze Tafel. Sie sitzt
 *   in `align-items: stretch` und reicht von der Kopfleiste bis zum unteren
 *   Rand, bündig mit der rechten Fensterkante. Mit dem Rahmen der Hülle stünde
 *   sie stattdessen als schwebender Block mit 36px Luft rechts, 56px oben und
 *   96px unten — sichtbar falsch, weil eine Tafel keine Karte ist.
 * - **Aufgaben** setzt seine Spalten (`padding: 56px 0 0`) randlos und gibt
 *   Titel, Reiter und Filterzeile ihre 36px selbst. Nur so laufen Board und
 *   Zeitstrahl über die volle Breite, und nur so zieht die Trennlinie über
 *   Liste und Zeitstrahl durch.
 *
 * Diese Seiten bringen ihre Abstände selbst mit. Die Funktion sagt der Hülle,
 * dass sie sich heraushalten soll — dieselbe Rolle, die `brotkrume` für die
 * Beschriftung hat: eine reine Abbildung von Adresse auf Verhalten, damit die
 * Hülle keine Liste von Sonderfällen im Rumpf trägt.
 */

/** Trifft `/aufgaben/<id>`, aber nicht `/aufgaben` selbst. */
const AUFGABE_DETAIL = /^\/aufgaben\/[^/]+$/;

/** Trifft `/projekte/<id>/meilensteine/<id>`. */
const MEILENSTEIN_DETAIL = /^\/projekte\/[^/]+\/meilensteine\/[^/]+$/;

/** Seitenliste und Seitendetail setzen ihren dreiteiligen Arbeitsbereich selbst. */
const SEITEN_ARBEITSBEREICH =
  /^\/projekte\/[^/]+\/seiten(?:\/[^/]+)?\/?$/;

export function istRandlos(pfad: string): boolean {
  if (pfad === "/aufgaben") return true;
  if (AUFGABE_DETAIL.test(pfad)) return true;
  if (MEILENSTEIN_DETAIL.test(pfad)) return true;
  if (SEITEN_ARBEITSBEREICH.test(pfad)) return true;
  // Die Aufgabenliste im Projektkontext ist dieselbe Seite.
  if (/^\/projekte\/[^/]+\/aufgaben$/.test(pfad)) return true;
  return false;
}
